import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectFilterByCreatedModal = createSelector(
  [(store: RootState) => store.documentsSignerList.showFilterByCreatedModal],
  (type) => type
);
